import { render, staticRenderFns } from "./SpadD_Details.vue?vue&type=template&id=27b96c7e"
import script from "./SpadD_Details.vue?vue&type=script&lang=js"
export * from "./SpadD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports